import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { convertAWSDateToLocalTime, submitReportData } from "../../utils";
import { useDataProvider, useNotify } from "react-admin";

const ReviewPatrol = ({ data, onBack }) => {
  // Pagination states
  const [page, setPage] = useState(0);
  const [reCheckpoints, setReCheckpoints] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const theme = useTheme();

  useEffect(() => {
    Promise.all(data.checkpoints.map(async (item) => ({
      ...item,
      image_base64: await item.image_base64,
    })))
    .then(setReCheckpoints).catch((err) => console.log("Error loading image:", err));
  }, [])

  // Handle Page Change
  const handleChangePage = (_, newPage) => setPage(newPage);

  // Handle Rows Per Page Change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSubmit = async () => {
    const reportReviewData = {
      ...data,
      end_time: (new Date()).toISOString(),
      checkpoints: reCheckpoints,
    }

    try {
      setIsSubmitting(true);
      await submitReportData(reportReviewData);
      await dataProvider.update("patrols", {
        id: data.patrol_id,
        data: {
          id: data.patrol_id,
          completed: true,
        }
      });
      notify("Submit success", { type: "success" });
      window.close();
    } catch (error) {
      console.log("Submit Report Review Error", error);
      notify("Failed success", { type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Paper sx={{ padding: 2, display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box sx={{ fontSize: 20, fontWeight: "bold", marginBottom: 2 }}>Review Patrol</Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ flexGrow: 1, overflowY: 'auto' }}>
        <Table>
          <TableHead sx={{ backgroundColor: theme.palette.background.paper }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", width: "5%" }}>NO</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "20%" }}>CHECKPOINT NAME</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "15%" }}>TIME COMPLATED</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "20%" }}>CHECKLIST</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "10%" }}>SNAPSHOT</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "20%" }}>NOTES</TableCell>
              <TableCell sx={{ fontWeight: "bold", width: "10%" }}>INCIDENTS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reCheckpoints.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, idx) => (
              <TableRow key={idx} hover>
                <TableCell>{idx + 1 + page * rowsPerPage}</TableCell>
                <TableCell>{item.checkpoint_name}</TableCell>
                <TableCell>{convertAWSDateToLocalTime(item.completed_at)}</TableCell>
                <TableCell>
                  {item.checklist_results.items.map((check, i) => (
                    <Typography key={i} sx={{ fontSize: 14 }}>
                      {check?.checked ? '✔' : '✖'} {check?.item}
                    </Typography>
                  ))}
                </TableCell>
                <TableCell>
                  <img src={item.image_base64} alt="snapshot" style={{ borderRadius: 10, maxWidth: '200px' }} />
                </TableCell>
                <TableCell>{item.notes}</TableCell>
                <TableCell>{item.incident_name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={reCheckpoints.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[5, 10, 25]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ minHeight: '70px' }}
      />

      {/* Buttons */}
      <Box sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onBack} sx={{ mr: 2 }} disabled={isSubmitting}>Back</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isSubmitting}>Submit</Button>
      </Box>
    </Paper>
  );
};

export default ReviewPatrol;
export { ReviewPatrol };
